/**
 * @description Storage types (enum)
 */
export enum StorageTypesEnum {
  Local = 'local',
  Session = 'session',
  Cookies = 'cookies'
};
